import React from "react";
import { Loader } from "semantic-ui-react";
import { useCustomQuery } from "utilities/hookutils";
import ArtistButtonList from "./ArtistButtonList";
import ArtistPickerDropdown from "./ArtistPickerDropdown";

interface Props {
  value: server.dto.ArtistSmall
  onChanged: (artist: server.dto.ArtistSmall | undefined) => void
  filter: server.dto.ArtistSecurityScopes
  error?: boolean

  excludeKeys?: number[]
  // If no artist is provided, the first artist is selected when it's loaded
  selectFirstArtist?: boolean
  autoFocus?: boolean

}

const ArtistPicker = (props: Props) => {
  if (!props.filter) {
    throw new Error("Filter must be provided");
  }

  const artistApi = useCustomQuery({
    queryFn: async () => {
      const res = await window.CoreApi.Artist.PaginatedSmall({
        artistSecurityScope: props.filter,
        page: 1,
        perPage: 100,
        excludeKeys: props.excludeKeys ?? []
      })
      return res.data;
    },
    queryKey: ["artistpicker", props.filter],
  });

  React.useEffect(() => {
    if(artistApi.data != null && props.selectFirstArtist && props.value == null && artistApi.data.data.length > 0) {
      props.onChanged(artistApi.data.data[0]);
    }
  }, [artistApi.data])

  if (artistApi.isLoading) {
    return <Loader active inline size="small" />
  }
  
  if (artistApi.data.absoluteCount <= window.serverReference.constants.artistPicker.threshold) {
    return <ArtistButtonList
      allArtists={artistApi.data.data}
      onChanged={props.onChanged}
      value={props.value}
      error={props.error}
      excludeKeys={props.excludeKeys}
    />;
  }

  return <ArtistPickerDropdown
    allArtists={artistApi.data.data}
    recentlyUsed={[]}
    onChanged={props.onChanged}
    value={props.value}
    error={props.error}
    excludeKeys={props.excludeKeys}
    autoFocus={props.autoFocus}
  />;
};

export default ArtistPicker;